import React, { Component } from "react";
import Utils from '../../utils/utils'

class PropertyValue extends Component {
  maxLength = 10;
  minLeft = 0;

  constructor(props) {
    super(props);

    this.state = {
      props: this.props,
      focused: false
    };
  }

  componentDidMount() {
    this.props.change(this.change);
    this.inputValue = this.refs.inputValue;

    if (this.inputValue) {
      this.inputValue.onfocus = e => {
        this.setState({
          focused: true
        });
      };
      this.inputValue.onblur = e => {
        this.setState({
          focused: false
        });
      };
    }
  }

  render() {
    return this.onRender();
  }

  getNiceValue() {
    if (this.props.getValue().length > this.maxLength)
      return this.props.getValue().substr(0, this.maxLength) + "...";
    return this.props.getValue();
  }

  change(value) {
    if (this.props.onChange) this.props.onChange(value);
  }

  handleChange(e) {
    const newVal = e.target.value;
    this.change(newVal);
    this.setState({
      value: newVal
    });
  }

  onRender() {
    const inputStyle = {};
    if(this.state.focused && this.inputValue) {
      const bounds = this.inputValue.getBoundingClientRect();

      if(!this.minLeft) {
        this.minLeft = bounds.left;
        this.baseWidth = bounds.width;
      }

      const valWidth = Utils.getStringWidth(this.props.getValue()) + 10;
      const moreLeft = bounds.width - valWidth;

      let newLeft = bounds.left + (moreLeft < 0 ? 0 : moreLeft - 8) - 2;

      if(bounds.width > this.baseWidth) {
        newLeft = bounds.left;
      }

      inputStyle.width = valWidth;
      inputStyle.position = "fixed";
      inputStyle.top = bounds.top;
      inputStyle.left = (newLeft < this.minLeft ? this.minLeft : newLeft);
      inputStyle.zIndex = "11";
      inputStyle.paddingRight = "5px";
    }

    return (
      <input
        style={inputStyle}
        ref="inputValue"
        type="text"
        value={this.state.focused ? this.props.getValue() : this.getNiceValue()}
        onChange={this.handleChange.bind(this)}
      />
    );
  }
}

export default PropertyValue;



// WEBPACK FOOTER //
// ./src/components/ui/PropertyValue.js